import { CallApi } from 'utils';
const { REACT_APP_TOKEN_API } = process.env;

/**
 * initialize static object
 * @param {string} ticketAlias
 * @param {object} initStatic
 * @returns object
 */
export const getStaticData = async (ticketAlias, initStatic) => {
  const header = {
    Authorization: [REACT_APP_TOKEN_API],
    ticketAlias: ticketAlias,
  };

  try {
    const response = await CallApi('get', 'static', '', '', header);
    const data = response?.[0]?.data ? response[0].data : null;
    const staticData = data
      ? { id: ticketAlias, ...data }
      : { ...initStatic, error: '' /* data.error  */ };

    return staticData;
  } catch (e) {
    console.log(e);
    return e;
  }
};

/**
 * Initialize ticket order object
 * @param {string} ticketAlias
 * @param {object} initTicket
 * @param {string} idSession
 * @returns ticket object
 */
export const getTicketOrder = async (ticketAlias, initTicket, idSession) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      idSession: idSession,
    };
    const response = await CallApi('get', 'ticket', '', '', header);
    const data = response?.[0]?.data ? response[0].data : null;
    const ticket = data
      ? { id: ticketAlias, ...data }
      : { ...initTicket, error: 'error' /* data.error */ };

    return ticket;
  } catch (e) {
    console.log(e);
    return e;
  }
};

/**
 * init list of ticket from cookies
 * @param {string} idSession
 * @returns array
 */
export const getTicketsList = async (idSession) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      idSession: idSession,
    };
    const response = await CallApi('get', 'tickets', '', '', header);
    const data = response?.[0]?.data ? response[0].data : null;
    const ticket = data?.tickets
      ? data.tickets
      : { error: 'error' /* data.error */ };

    return ticket;
  } catch (e) {
    console.log(e);
    return e;
  }
};

/**
 * GET new cookie
 * @param {string} ticketAlias
 * @param {string} idSession
 * @returns array
 */
export const postRenewCookie = async (ticketAlias, idSession) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      idSession: idSession,
    };
    const body = {
      empty: true,
    };
    const response = await CallApi('post', 'setCookie', '', body, header);
    const data = response?.[0]?.ok ? response[0].ok : null;
    const ticket = data ? data : { error: 'error' /* data.error */ };
    return ticket;
  } catch (e) {
    console.log(e);
    return e;
  }
};

/**
 * get cookie
 * @param {string} ticketAlias
 * @param {string} idSession
 * @returns
 */
export const getCookie = async (ticketAlias, idSession) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      idSession: idSession,
    };
    const response = await CallApi('get', 'setCookie', '', '', header);
    const data = response?.[0]?.ok ? response[0].ok : null;
    const ticket = data ? data : false;
    return ticket;
  } catch (e) {
    console.log(e);
    return e;
  }
};

/**
 * init pay plus
 * @param {string} ticketAlias
 * @param {string} idSession
 * @param {object} body
 * @returns
 */
export const getPayPlusData = async (
  ticketAlias,
  idSession,
  body,
  source = null,
) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      idSession: idSession,
    };
    const response = await CallApi(
      'post',
      'ticket',
      '',
      body,
      header,
      {},
      source,
    );

    const data = response?.[0]?.ok ? response[0] : null;
    return data
      ? data
      : {
          success: false,
          error: 'error' /*  data.error */,
          idSessionPayPlus: null,
        };
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const postCanPayAmount = async (
  amount,
  idTransaction,
  idSession,
  ticketAlias,
  tips,
) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      idSession: idSession,
    };
    const body = {
      idTransaction,
      amount,
      tips,
    };
    const response = await CallApi('post', 'canPay', '', body, header);
    const data = response?.[0] ? response[0] : null;
    return data
      ? data
      : {
          success: false,
          error: 'error' /*  data.error */,
          idSessionPayPlus: null,
        };
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const paymentProcessCompleted = async (
  idTransaction,
  idSession,
  ticketAlias,
) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      idSession: idSession,
    };
    const body = {
      idTransaction,
    };
    const response = await CallApi(
      'post',
      'paymentProcessCompleted',
      '',
      body,
      header,
    );
    const data = response?.[0] ? response[0] : null;
    return data
      ? data
      : {
          success: false,
          error: 'error' /*  data.error */,
        };
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const postConfirmPay = async (body, idSession, ticketAlias) => {
  try {
    const header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      idSession: idSession,
    };
    const response = await CallApi('post', 'confirmPay', '', body, header);
    const data = response?.[0] ? response[0] : null;
    return data
      ? data
      : {
          success: false,
          error: 'error',
          idSessionPayPlus: null,
        };
  } catch (e) {
    console.log(e);
    return e;
  }
};
